import { render, staticRenderFns } from "./FormFinance.vue?vue&type=template&id=0bae6e0d&"
import script from "./FormFinance.vue?vue&type=script&lang=js&"
export * from "./FormFinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports